<div id="divBanner" *ngIf="isShowBanner">
    <span class="bg-banner banner-css p-1 container-fluid text-decoration-none" style="background-color: #DE8269;">
            <span class="f-s-14 text-white">
                <b><span class="animated-sparkle">✨</span> You're invited to try the new Oversight360 experience! <a class="text-decoration-none" id="banner-redirect" name="banner-redirect" target="_blank" href="https://portal.oversight360.copeland.com/"> [Click here]</a> to open the redesigned UI in a new tab.</b>
            </span>
    </span>
    <a class="topcorner" id="banner-close" name="banner-close" (click)="OnCloseButtonClick()">
        <span>
            <i class="fa fa-times text-white"></i>
        </span>
    </a>
</div>